import Slider from 'react-slick';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import React, {Component} from 'react';

import ObjectPreview from '../Base/PropertyPreview';

const propTypes = {
    requiredType: PropTypes.string.isRequired
};

class YouWillAlsoLike extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isShowSlider: false
        }
    }

    componentDidMount() {
        // Задержка для слайдера из-за того, что изначально неверно рассчитывается ширина
        setTimeout(() => {
                this.setState({
                    isShowSlider: true
                })
            },
            1000
        );
    }

    render() {
        const {i18n, requiredType} = this.props;
        const sliderSettings = {
            speed: 1000,
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            swipeToSlide: true,
            touchThreshold: 100,
            className: 'you-like-items'
        };

        return (
            <div className="rent-you-like">
                <h2>{i18n['objectPage.youWillAlsoLike']}</h2>
                {this.state.isShowSlider && <Slider {...sliderSettings}>
                    {this.props.youWillAlsoLike.slice(0, 5).map(object =>
                        <ObjectPreview
                            key={object.id}
                            object={object}
                            requiredType={requiredType}
                        />
                    )}
                </Slider>}
            </div>
        )
    }
}

YouWillAlsoLike.propTypes = propTypes;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    youWillAlsoLike: state.objectPage.youWillAlsoLike
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(YouWillAlsoLike);


// WEBPACK FOOTER //
// ./src/components/PropertyPage/YouWillAlsoLike.js